export interface BuySellSplitData {
  buyCount: number
  sellCount: number
}

export interface BuySellSplitProps {
  data?: BuySellSplitData
  className?: string
  buyPercentage?: number
  sellPercentage?: number
  buyCount?: number
  sellCount?: number
}

export interface BuySellSplitComputedValues {
  buyPct: number
  sellPct: number
}

export const getBuySellPercentages = ({
  buyCount,
  sellCount,
  buyPercentage,
  sellPercentage
}: {
  buyCount: number
  sellCount: number
  buyPercentage?: number
  sellPercentage?: number
}): BuySellSplitComputedValues => {
  const total = buyCount + sellCount

  if (total === 0) {
    return { buyPct: 50, sellPct: 50 }
  }

  if (buyPercentage !== undefined && sellPercentage !== undefined) {
    return {
      buyPct: Math.round(buyPercentage),
      sellPct: Math.round(sellPercentage)
    }
  }

  const computedBuyPct = Math.round((buyCount / total) * 100)
  return {
    buyPct: computedBuyPct,
    sellPct: 100 - computedBuyPct
  }
}
